import * as t from 'io-ts';

const tvGuideFeedApi = t.type({
  EventId: t.number,
  StartDate: t.string,
  EndDate: t.string,
  Sport: t.string,
  Channel: t.string,
  ChannelShortName: t.string,
  Type: t.string,
  Title: t.string,
  Detail: t.string,
  ActiveTitle: t.string,
  ActiveDetail: t.string,
  Rank: t.number,
  Order: t.number,
});
export const tvGuideFeedApiResponse = t.array(tvGuideFeedApi);
export type TvGuideFeed = t.TypeOf<typeof tvGuideFeedApiResponse>;
